/**
 * System application IDs
 * These are reserved application identifiers used by the auth system
 */
export const SYSTEM_APP_IDS = {
    /** Auth Admin Portal - administrative UI for user and application management */
    AUTH_ADMIN: 'auth-admin',
};
/**
 * Default roles available for applications
 */
export const DEFAULT_ROLES = ['Admin', 'manager', 'user'];
